module.exports = __webpack_public_path__ + "assets/img/00104.cd5e3357.png";